import SkuCalculator from './containers/SkuCalculator';

export default SkuCalculator;
